/* eslint-disable-next-line no-restricted-imports */
import type { StoreSpecial } from '@jane/shared/models';
import { QUALIFIED_GROUP_TYPE_MAP } from '@jane/shared/util';

export const formatDiscountAmount = ({
  discount_type,
  discount_percent,
  discount_dollar_amount,
  discount_target_price,
}: {
  discount_dollar_amount: number;
  discount_percent: number;
  discount_target_price: number;
  discount_type: string;
}) => {
  switch (discount_type) {
    case 'percent':
      return `${discount_percent}%`;
    case 'dollar_amount':
      return `$${discount_dollar_amount}`;
    case 'target_price':
      return `$${discount_target_price}`;
    default:
      throw new Error(`unknown special discount type: ${discount_type}`);
  }
};

export const formatTitle = (special: StoreSpecial) => {
  const {
    special_type,
    title,
    rules,
    discount_type,
    discount_percent,
    discount_dollar_amount,
    discount_target_price,
  } = special;

  if (special_type === 'qualified_group' && rules?.base?.type) {
    const discountDetails = formatDiscountAmount({
      discount_type,
      discount_percent,
      discount_dollar_amount,
      discount_target_price,
    });

    return `${
      rules.base.type === 'medical'
        ? 'Medical patients'
        : QUALIFIED_GROUP_TYPE_MAP[rules.base.type]
    } – ${discountDetails} OFF`;
  }

  return title;
};
